import { enumCacheLevel } from '@/cache/cacheEnum';
export default {
    //Cấu hình cache cho dashboard theo cấu trúc 'Das_{Tên enum dashboardtype}'
    "Das_STC_SummaryAllocationDeliveryBar":
    {
        KeyFormat: "das_{dashboard_type}_{param_key}",
        CacheLevel: enumCacheLevel.CacheIndexDB,
        ExpireTimeoutInSecond: 600,
        Note: "Cache dữ liệu dashboard STC_SummaryAllocationDeliveryBar",
    },
    "Das_STC_SummaryAllocationDeliveryPie":
    {
        KeyFormat: "das_{dashboard_type}_{param_key}",
        CacheLevel: enumCacheLevel.CacheIndexDB,
        ExpireTimeoutInSecond: 600,
        Note: "Cache dữ liệu dashboard STC_SummaryAllocationDeliveryPie",
    },
    "Das_Fee_Expense_Chart":
    {
        KeyFormat: "das_{dashboard_type}_{param_key}",
        CacheLevel: enumCacheLevel.CacheIndexDB,
        ExpireTimeoutInSecond: 600,
        Note: "Cache dữ liệu dashboard Fee_Expense_Chart",
    },
    "Das_Fee_Revenue_Chart":
    {
        KeyFormat: "das_{dashboard_type}_{param_key}",
        CacheLevel: enumCacheLevel.CacheIndexDB,
        ExpireTimeoutInSecond: 600,
        Note: "Cache dữ liệu dashboard Fee_Revenue_Chart",
    },
    "Das_Business_Revenue_Chart":
    {
        KeyFormat: "das_{dashboard_type}_{param_key}",
        CacheLevel: enumCacheLevel.CacheIndexDB,
        ExpireTimeoutInSecond: 600,
        Note: "Cache dữ liệu dashboard Business_Revenue_Chart",
    },
    "Das_Budget_Expense_Chart":
    {
        KeyFormat: "das_{dashboard_type}_{param_key}",
        CacheLevel: enumCacheLevel.CacheIndexDB,
        ExpireTimeoutInSecond: 600,
        Note: "Cache dữ liệu dashboard Das_Budget_Expense_Chart",
    },
    "Das_Budget_Expense_ByTask_Chart":
    {
        KeyFormat: "das_{dashboard_type}_{param_key}",
        CacheLevel: enumCacheLevel.CacheIndexDB,
        ExpireTimeoutInSecond: 600,
        Note: "Cache dữ liệu dashboard Das_Budget_Expense_ByTask_Chart",
    },
    "Das_Budget_Expense_By_Field_Chart":
    {
        KeyFormat: "das_{dashboard_type}_{param_key}",
        CacheLevel: enumCacheLevel.CacheIndexDB,
        ExpireTimeoutInSecond: 600,
        Note: "Cache dữ liệu dashboard Das_Budget_Expense_By_Field_Chart",
    },
    "Das_Budget_Expense_By_Property_Chart":
    {
        KeyFormat: "das_{dashboard_type}_{param_key}",
        CacheLevel: enumCacheLevel.CacheIndexDB,
        ExpireTimeoutInSecond: 600,
        Note: "Cache dữ liệu dashboard Das_Budget_Expense_By_Property_Chart",
    },
    "Das_Business_Expense_Chart":
    {
        KeyFormat: "das_{dashboard_type}_{param_key}",
        CacheLevel: enumCacheLevel.CacheIndexDB,
        ExpireTimeoutInSecond: 600,
        Note: "Cache dữ liệu dashboard Das_Business_Expense_Chart",
    },

    //CQSN
    "Das_Fee_Expense_CQSN_Chart": {
        KeyFormat: "das_{dashboard_type}_{param_key}",
        CacheLevel: enumCacheLevel.CacheIndexDB,
        ExpireTimeoutInSecond: 600,
        Note: "Cache dữ liệu dashboard Fee_Expense_CQSN_Chart",
    },
    "Das_Fee_Revenue_CQSN_Chart": {
        KeyFormat: "das_{dashboard_type}_{param_key}",
        CacheLevel: enumCacheLevel.CacheIndexDB,
        ExpireTimeoutInSecond: 600,
        Note: "Cache dữ liệu dashboard Fee_Revenue_CQSN_Chart",
    },
    // "Das_Fee_Revenue_Detail_CQSN_Chart": {
    //     KeyFormat: "das_{dashboard_type}_{param_key}",
    //     CacheLevel: enumCacheLevel.CacheIndexDB,
    //     ExpireTimeoutInSecond: 600,
    //     Note: "Cache dữ liệu dashboard Fee_Revenue_Detail_CQSN_Chart",
    // },
    // "Das_Fee_Expense_Detail_CQSN_Chart": {
    //     KeyFormat: "das_{dashboard_type}_{param_key}",
    //     CacheLevel: enumCacheLevel.CacheIndexDB,
    //     ExpireTimeoutInSecond: 600,
    //     Note: "Cache dữ liệu dashboard Fee_Expense_Detail_CQSN_Chart",
    // },
    "Das_Business_Expense_CQSN_Chart": {
        KeyFormat: "das_{dashboard_type}_{param_key}",
        CacheLevel: enumCacheLevel.CacheIndexDB,
        ExpireTimeoutInSecond: 600,
        Note: "Cache dữ liệu dashboard Business_Expense_CQSN_Chart",
    },
    "Das_Budget_Expense_CQSN_Chart": {
        KeyFormat: "das_{dashboard_type}_{param_key}",
        CacheLevel: enumCacheLevel.CacheIndexDB,
        ExpireTimeoutInSecond: 600,
        Note: "Cache dữ liệu dashboard Budget_Expense_CQSN_Chart",
    },
    "Das_Budget_Expense_ByTask_CQSN_Chart": {
        KeyFormat: "das_{dashboard_type}_{param_key}",
        CacheLevel: enumCacheLevel.CacheIndexDB,
        ExpireTimeoutInSecond: 600,
        Note: "Cache dữ liệu dashboard Budget_Expense_ByTask_CQSN_Chart",
    },
    "Das_Budget_Expense_Detail_CQSN_Chart": {
        KeyFormat: "das_{dashboard_type}_{param_key}",
        CacheLevel: enumCacheLevel.CacheIndexDB,
        ExpireTimeoutInSecond: 600,
        Note: "Cache dữ liệu dashboard Budget_Expense_Detail_CQSN_Chart",
    },
    "Das_Business_Revenue_CQSN_Chart": {
        KeyFormat: "das_{dashboard_type}_{param_key}",
        CacheLevel: enumCacheLevel.CacheIndexDB,
        ExpireTimeoutInSecond: 600,
        Note: "Cache dữ liệu dashboard Business_Revenue_CQSN_Chart",
    },
    "Das_Business_Revenue_Detail_CQSN_Chart": {
        KeyFormat: "das_{dashboard_type}_{param_key}",
        CacheLevel: enumCacheLevel.CacheIndexDB,
        ExpireTimeoutInSecond: 600,
        Note: "Cache dữ liệu dashboard Business_Revenue_Detail_CQSN_Chart",
    },
    "Das_Budget_Expense_By_Field_CQSN_Chart": {
        KeyFormat: "das_{dashboard_type}_{param_key}",
        CacheLevel: enumCacheLevel.CacheIndexDB,
        ExpireTimeoutInSecond: 600,
        Note: "Cache dữ liệu dashboard Budget_Expense_By_Field_CQSN_Chart",
    },
    "Das_Budget_Expense_By_Property_CQSN_Chart": {
        KeyFormat: "das_{dashboard_type}_{param_key}",
        CacheLevel: enumCacheLevel.CacheIndexDB,
        ExpireTimeoutInSecond: 600,
        Note: "Cache dữ liệu dashboard Budget_Expense_By_Property_CQSN_Chart",
    },
};
